import { useEffect } from "react";
import Lenis from "lenis";
import "@/index.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Tiers from "@/components/Tiers";
import Engine from "@/components/Engine";
import Process from "@/components/Process";
import WhyFocs from "@/components/WhyFocs";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);

        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const el = document.querySelector(a.getAttribute("href"));
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -64 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            document.removeEventListener("click", onClick);
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div id="top" className="bg-ink font-sans text-white antialiased">
            <div className="grain" aria-hidden="true" />
            <Nav />
            <main>
                <Hero />
                <Stats />
                <Marquee />
                <Services />
                <Tiers />
                <Engine />
                <Process />
                <WhyFocs />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
